(function(){
  "use strict";
  var MATERIALS = [
    {id:"pea_gravel",  name:"Pea Gravel (1/4\"-3/8\")",        density:96,  use:"Patios, walkways, dog runs"},
    {id:"all_purpose", name:"All-Purpose Gravel (1/4\"-2\")",  density:105, use:"Paths, beds & general fill"},
    {id:"crushed_57",  name:"Crushed Stone #57",               density:100, use:"Raised-bed, shed & greenhouse bases"},
    {id:"river_rock",  name:"River Rock (2\"-6\")",            density:98,  use:"Decorative beds & borders"},
    {id:"dg",          name:"Decomposed Granite",              density:110, use:"Natural garden paths"},
    {id:"lava_rock",   name:"Lava Rock (lightweight)",         density:45,  use:"Decorative mulch, xeriscape"},
    {id:"paver_sand",  name:"Paver / Bedding Sand",            density:100, use:"Leveling base under gravel/pavers"},
    {id:"custom",      name:"Custom density...",               density:null,use:""}
  ];
  var $=function(id){return document.getElementById(id);};
  var shape="rectangle";

  var matSel=$("ee-mat");
  MATERIALS.forEach(function(m){var o=document.createElement("option");o.value=m.id;o.textContent=m.name;matSel.appendChild(o);});
  function matById(id){return MATERIALS.filter(function(m){return m.id===id;})[0];}
  function refreshMatUse(){
    var m=matById(matSel.value);
    $("ee-mat-use").textContent=m.use?"Best for: "+m.use:"";
    $("f-density").classList.toggle("hidden", m.id!=="custom");
  }
  matSel.addEventListener("change",refreshMatUse);
  refreshMatUse();

  // Shape buttons
  var shapeBtns=Array.prototype.slice.call(document.querySelectorAll("#shapes .shape"));
  function selectShape(btn){
    shape=btn.getAttribute("data-shape");
    shapeBtns.forEach(function(b){b.classList.toggle("active", b===btn);});
    ["rectangle","circle","area"].forEach(function(p){
      var on=(p===shape);
      document.querySelectorAll('[data-pane="'+p+'"]').forEach(function(el){el.classList.toggle("hidden", !on);});
    });
  }
  shapeBtns.forEach(function(btn){btn.addEventListener("click",function(){selectShape(btn);});});

  // Depth chips
  document.querySelectorAll(".chips button").forEach(function(chip){
    chip.addEventListener("click",function(){$("ee-depth").value=chip.getAttribute("data-depth");$("ee-depth-u").value="in";});
  });

  var TO_FT={in:1/12, ft:1, yd:3};
  function val(id){var v=parseFloat($(id).value);return isNaN(v)?0:v;}

  function refreshBagHint(){
    var show=val("ee-bag")>0 && $("ee-price-u").value!=="bag";
    $("ee-bag-hint").style.display=show?"block":"none";
  }
  $("ee-bag").addEventListener("input",refreshBagHint);
  $("ee-price-u").addEventListener("change",refreshBagHint);

  function areaSqFt(){
    if(shape==="rectangle"){return (val("ee-len")*TO_FT[$("ee-len-u").value])*(val("ee-wid")*TO_FT[$("ee-wid-u").value]);}
    if(shape==="circle"){var r=(val("ee-dia")*TO_FT[$("ee-dia-u").value])/2;return Math.PI*r*r;}
    var a=val("ee-area");return $("ee-area-u").value==="sqyd"?a*9:a;
  }
  function fmt(n,dp){dp=(dp==null)?2:dp;if(!isFinite(n))n=0;return n.toLocaleString("en-US",{minimumFractionDigits:dp,maximumFractionDigits:dp});}
  function fmtQty(n,dp){if(!isFinite(n)||n<=0)return fmt(0,dp);var min=Math.pow(10,-dp);if(n<min)return "<"+min.toFixed(dp);return fmt(n,dp);}

  function calculate(){
    var area=areaSqFt();
    var depthFt=val("ee-depth")*TO_FT[$("ee-depth-u").value];
    var err=$("ee-error");
    if(area<=0 || depthFt<=0){
      err.classList.add("show");$("ee-results").classList.remove("show");err.focus();return;
    }
    err.classList.remove("show");
    var m=matById(matSel.value);
    var density=(m.id==="custom")?val("ee-density"):m.density;
    if(density<=0)density=100;
    var ft3=area*depthFt;
    if($("ee-overage").checked)ft3*=1.10;
    var yd3=ft3/27;
    var tons=(ft3*density)/2000;
    var bagSize=val("ee-bag");
    var bags=bagSize>0?Math.ceil(ft3/bagSize):0;
    var price=val("ee-price"), priceUnit=$("ee-price-u").value, cost=0, costable=price>0;
    if(costable){
      if(priceUnit==="ton")cost=tons*price;
      else if(priceUnit==="yd3")cost=yd3*price;
      else if(priceUnit==="bag")cost=(bags>0?bags:Math.ceil(ft3/0.5))*price;
    }
    $("ee-r-yd3").textContent=fmtQty(yd3,2);
    $("ee-r-ft3").textContent=fmtQty(ft3,1)+" cubic feet";
    $("ee-r-tons").textContent=fmtQty(tons,2);
    var bagsTile=$("ee-r-bags-tile"), costTile=$("ee-r-cost-tile");
    if(bags>0){bagsTile.classList.remove("hidden");$("ee-r-bags").textContent=fmt(bags,0);}else bagsTile.classList.add("hidden");
    if(costable){
      costTile.classList.remove("hidden");$("ee-r-cost").textContent="$"+fmt(cost,2);
      $("ee-r-cost-lbl").textContent="at $"+fmt(price,2)+"/"+(priceUnit==="yd3"?"yd³":priceUnit);
    }else costTile.classList.add("hidden");
    $("ee-r-note").textContent="Based on "+(m.id==="custom"?"custom density":m.name)+" at ~"+fmt(density,0)+" lb/ft³. Gravel density varies by supplier and moisture - confirm tonnage before ordering bulk.";
    var res=$("ee-results");res.classList.add("show");res.scrollIntoView({behavior:"smooth",block:"nearest"});
  }
  $("ee-calc").addEventListener("click",calculate);
  $("ee-reset").addEventListener("click",function(){
    ["ee-len","ee-wid","ee-dia","ee-area","ee-price","ee-bag","ee-density"].forEach(function(id){$(id).value="";});
    $("ee-depth").value="2";$("ee-depth-u").value="in";$("ee-overage").checked=true;
    $("ee-results").classList.remove("show");$("ee-error").classList.remove("show");refreshBagHint();
  });
  // Enter key triggers calc from any input
  document.querySelectorAll("#gravel-tool input").forEach(function(inp){
    inp.addEventListener("keydown",function(e){if(e.key==="Enter"){e.preventDefault();calculate();}});
  });
})();
